import {trackPromise} from "react-promise-tracker";
import CallV2 from "../../service/axiosV2";
import {getUrl} from "../../constants/urls";

export const getEventRulesAsync = (pageUrl) => {
  const url = pageUrl ? pageUrl : getUrl("listEventRules");

  return trackPromise(CallV2.get(url));
};

export const createUpdateEventRuleAsync = (data = {}) => {
  const {id = ""} = data;
  const url = getUrl("listEventRules");
  // The form shows the conditions error under the field, so it is not toasted too.
  const config = {skipErrorToastFields: ["conditions"]};

  if (id) {
    const patchUrl = `${url}${id}/`;
    return trackPromise(CallV2.patch(patchUrl, data, config));
  } else {
    return trackPromise(CallV2.post(url, data, config));
  }
};

export const deleteEventRuleAsync = (id = "") => {
  const url = getUrl("listEventRules");
  const deleteUrl = `${url}${id}/`;

  return trackPromise(CallV2.delete(deleteUrl));
};

export const getContentTypesAsync = () => {
  const url = getUrl("eventObjectTypes");
  return trackPromise(CallV2.get(url));
};

export const getEventFieldTypesAsync = () => {
  const url = getUrl("eventFieldTypes");
  return trackPromise(CallV2.get(url));
};

export const getEventWebhooksAsync = () => {
  const url = getUrl("eventWebhook");
  return trackPromise(CallV2.get(url));
};
